import React, { Suspense, lazy } from 'react'; // Added Suspense and lazy
import { Routes, Route } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material'; // Added CircularProgress for loading spinner
import { PayPalScriptProvider } from '@paypal/react-paypal-js';

import Navbar from './Navbar';
import HomePage from './HomePage';
import LoginPage from './LoginPage';
import RegisterPage from './RegisterPage';
import AddDisplay from './AddDisplay';
import MySubmissionsPage from './MySubmissionsPage';
import InfoPage from './InfoPage';
import PrivacyPolicy from './PrivacyPolicy';
import AboutPage from './AboutPage';     
import ContactPage from './ContactPage'; 
import GamesPage from './GamesPage'; 
import Footer from './Footer';         
import './App.css';
import Snowfall from 'react-snowfall';
import CornerAnimation from './CornerAnimation'; 
import SuburbPage from './SuburbPage'; 
import ResetPasswordPage from './ResetPasswordPage';
import GoodbyePage from './pages/GoodbyePage';

// --- NEW COMPONENT IMPORT ---
import SearchDashboard from './components/SearchDashboard'; 
// ----------------------------

// --- Blog Imports (Converted to Lazy Loading) ---
const BlogPage = lazy(() => import('./BlogPage'));
const ChristmasLightsMapGuide = lazy(() => import('./posts/ChristmasLightsMapGuide'));
const TopMelbourne = lazy(() => import('./posts/TopMelbourne'));
const TopSydney = lazy(() => import('./posts/TopSydney'));
const TopBrisbane = lazy(() => import('./posts/TopBrisbane'));
const TopPerth = lazy(() => import('./posts/TopPerth'));
const TopBallarat = lazy(() => import('./posts/TopBallarat'));
const InternationalLights = lazy(() => import('./posts/InternationalLights'));
const InternationalGuide = lazy(() => import('./posts/InternationalGuide'));
const SantaGuide = lazy(() => import('./posts/SantaGuide'));
const PerthNorthernSuburbs = lazy(() => import('./posts/PerthNorthernSuburbs'));
const CoastalLights = lazy(() => import('./posts/CoastalLights'));
const HiddenGems = lazy(() => import('./posts/HiddenGems'));
const WesternSydneyLights = lazy(() => import('./posts/WesternSydneyLights'));
const TopIpswich = lazy(() => import('./posts/TopIpswich'));
const TopWollongong = lazy(() => import('./posts/TopWollongong'));
const NorthBrisbane = lazy(() => import('./posts/NorthBrisbane'));
const MacarthurLights = lazy(() => import('./posts/MacarthurLights'));
const HunterValleyLights = lazy(() => import('./posts/HunterValleyLights'));
const SouthWestSydney = lazy(() => import('./posts/SouthWestSydney'));
const RegionalVicLights = lazy(() => import('./posts/RegionalVicLights'));
const RegionalWALights = lazy(() => import('./posts/RegionalWALights'));
const CoastalWA = lazy(() => import('./posts/CoastalWA'));
const SouthPerthLights = lazy(() => import('./posts/SouthPerthLights'));
const GlenmoreParkGuide = lazy(() => import('./posts/GlenmoreParkGuide'));
const SheppartonGuide = lazy(() => import('./posts/SheppartonGuide'));
const TownsvilleGuide = lazy(() => import('./posts/TownsvilleGuide'));
const IvanhoeGuide = lazy(() => import('./posts/IvanhoeGuide'));
const KalgoorlieGuide = lazy(() => import('./posts/KalgoorlieGuide'));
const SouthernNSWLights = lazy(() => import('./posts/SouthernNSWLights'));
const AtwellGuide = lazy(() => import('./posts/AtwellGuide'));
const BathurstGuide = lazy(() => import('./posts/BathurstGuide'));
const WesternVicLights = lazy(() => import('./posts/WesternVicLights'));
const GippslandLights = lazy(() => import('./posts/GippslandLights'));
const SunshineCoastLights = lazy(() => import('./posts/SunshineCoastLights'));
const WhyallaGuide = lazy(() => import('./posts/WhyallaGuide'));
const ClarenceTownGuide = lazy(() => import('./posts/ClarenceTownGuide'));
const RegionalQLDLights = lazy(() => import('./posts/RegionalQLDLights'));
const YeppoonGuide = lazy(() => import('./posts/YeppoonGuide'));
const BlueMountainsLights = lazy(() => import('./posts/BlueMountainsLights'));
const RedcliffeGuide = lazy(() => import('./posts/RedcliffeGuide'));
const EchucaMoamaGuide = lazy(() => import('./posts/EchucaMoamaGuide'));
const GoulburnGuide = lazy(() => import('./posts/GoulburnGuide'));
const CairnsGuide = lazy(() => import('./posts/CairnsGuide'));
const BrisbaneSouthside = lazy(() => import('./posts/BrisbaneSouthside'));
const DubboGuide = lazy(() => import('./posts/DubboGuide'));
const SouthernAdelaideLights = lazy(() => import('./posts/SouthernAdelaideLights'));
const MelbourneNorthWest = lazy(() => import('./posts/MelbourneNorthWest'));
const GeelongLights = lazy(() => import('./posts/GeelongLights'));
const CentralCoastLights = lazy(() => import('./posts/CentralCoastLights'));
const SutherlandShireLights = lazy(() => import('./posts/SutherlandShireLights'));
const NewcastleNorthLights = lazy(() => import('./posts/NewcastleNorthLights'));
const MelbourneNorthernLights = lazy(() => import('./posts/MelbourneNorthernLights'));
const MelbourneBaysideLights = lazy(() => import('./posts/MelbourneBaysideLights'));
const HobartSouthLights = lazy(() => import('./posts/HobartSouthLights'));
const EastGippslandLights = lazy(() => import('./posts/EastGippslandLights'));
const PenrithLights = lazy(() => import('./posts/PenrithLights'));
const NarangbaLights = lazy(() => import('./posts/NarangbaLights'));
const CockburnLights = lazy(() => import('./posts/CockburnLights'));
const SydneyNorthShoreLights = lazy(() => import('./posts/SydneyNorthShoreLights'));
const PortMacquarieLights = lazy(() => import('./posts/PortMacquarieLights'));
const ToowoombaLights = lazy(() => import('./posts/ToowoombaLights'));
const LoganCityLights = lazy(() => import('./posts/LoganCityLights'));
const WarrnamboolLights = lazy(() => import('./posts/WarrnamboolLights'));
const GoldCoastLights = lazy(() => import('./posts/GoldCoastLights'));
const RockinghamLights = lazy(() => import('./posts/RockinghamLights'));
const BrokenHillLights = lazy(() => import('./posts/BrokenHillLights'));
const WhyallaLights = lazy(() => import('./posts/WhyallaLights'));
const BendigoLights = lazy(() => import('./posts/BendigoLights'));
const NumurkahLights = lazy(() => import('./posts/NumurkahLights'));
const KerangLights = lazy(() => import('./posts/KerangLights'));
const IpswichLights = lazy(() => import('./posts/IpswichLights'));
const CabooltureLights = lazy(() => import('./posts/CabooltureLights'));
const SheppartonLights = lazy(() => import('./posts/SheppartonLights'));
const DubboLights = lazy(() => import('./posts/DubboLights'));
const CairnsLights = lazy(() => import('./posts/CairnsLights'));
const HillsDistrictLights = lazy(() => import('./posts/HillsDistrictLights'));
const MelbourneWestLights = lazy(() => import('./posts/MelbourneWestLights'));
const NorthernBeachesLights = lazy(() => import('./posts/NorthernBeachesLights'));
const MandurahLights = lazy(() => import('./posts/MandurahLights'));
const NorthernAdelaideLights = lazy(() => import('./posts/NorthernAdelaideLights'));
const RowvilleLights = lazy(() => import('./posts/RowvilleLights'));
const MaryboroughLights = lazy(() => import('./posts/MaryboroughLights'));
const MeltonLights = lazy(() => import('./posts/MeltonLights'));
const TweedLights = lazy(() => import('./posts/TweedLights'));
const PortPirieLights = lazy(() => import('./posts/PortPirieLights'));
const AtwellLights = lazy(() => import('./posts/AtwellLights'));
const GregoryHillsLights = lazy(() => import('./posts/GregoryHillsLights'));
const WollongongLights = lazy(() => import('./posts/WollongongLights'));
const KalgoorlieLights = lazy(() => import('./posts/KalgoorlieLights'));
const CurrambineLights = lazy(() => import('./posts/CurrambineLights'));
const BairnsdaleLights = lazy(() => import('./posts/BairnsdaleLights'));
const CairnsCavalcade = lazy(() => import('./posts/CairnsCavalcade'));
const GregoryHills = lazy(() => import('./posts/GregoryHills'));
const AustraliaMap = lazy(() => import('./posts/AustraliaMap'));
const TraralgonLights = lazy(() => import('./posts/TraralgonLights'));
const CabooltureGuide = lazy(() => import('./posts/CabooltureGuide'));
const IvanhoeBoulevard = lazy(() => import('./posts/IvanhoeBoulevard'));
const CentralCoast2025 = lazy(() => import('./posts/CentralCoast2025'));
const VictoriaWeekendGuide = lazy(() => import('./posts/VictoriaWeekendGuide'));
const ChristmasEveGuide = lazy(() => import('./posts/ChristmasEveGuide'));
const ChristmasDayGuide = lazy(() => import('./posts/ChristmasDayGuide'));
const ChristmasDayBoxingDay = lazy(() => import('./posts/ChristmasDayBoxingDay'));
const NSWWeekendGuide = lazy(() => import('./posts/NSWWeekendGuide'));
const NYEFireworks2025 = lazy(() => import('./posts/NYEFireworks2025'));
const NYEFireworks2026 = lazy(() => import('./posts/NYEFireworks2026'));
const QLDWeekendGuide = lazy(() => import('./posts/QLDWeekendGuide'));
const SAWeekendGuide = lazy(() => import('./posts/SAWeekendGuide'));
const WAWeekendGuide = lazy(() => import('./posts/WAWeekendGuide'));
const BestLightsVIC = lazy(() => import('./posts/BestLightsVIC'));
const BestLightsNSW = lazy(() => import('./posts/BestLightsNSW'));
const BestLightsQLD = lazy(() => import('./posts/BestLightsQLD'));
const BestLightsWA = lazy(() => import('./posts/BestLightsWA'));
const BestLightsSA = lazy(() => import('./posts/BestLightsSA'));
const BestLightsTAS = lazy(() => import('./posts/BestLightsTAS'));
const BestLightsACT = lazy(() => import('./posts/BestLightsACT'));
const BestLightsNT = lazy(() => import('./posts/BestLightsNT'));
// --- Blog Imports 2026 (Converted to Lazy Loading) ---
const FestiveExpectations = lazy(() => import('./posts/FestiveExpectations'));

const paypalOptions = {
  "client-id": "ATdqEdoY6_5pGQ3Cl2MFxjw8MuaH9lOMIp2_bcUAz-Zet59_LMhPiYpDv4vFC_pXVCLD7C9iLCdqGfTH",
  currency: "AUD",
  intent: "capture",
};

function App() {
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
    }}>
      <Snowfall />
      <CornerAnimation /> 
      
      <Navbar />
      
      <Box component="main" sx={{ flexGrow: 1 }}>
        {/* Suspense Wraps the Routes to handle lazy loading */}
        <Suspense fallback={
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 10 }}>
            <CircularProgress />
          </Box>
        }>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            
            {/* --- NEW DASHBOARD ROUTE --- */}
            <Route path="/dashboard" element={<SearchDashboard />} />
            {/* --------------------------- */}

            {/* 3. WRAP ONLY THE ADD PAGE (Kept your logic) */}
            <Route path="/add" element={
              <PayPalScriptProvider options={paypalOptions}>
                <AddDisplay />
              </PayPalScriptProvider>
            } />
            {/* ------------------------- */}
            
            <Route path="/my-submissions" element={<MySubmissionsPage />} />
            <Route path="/info" element={<InfoPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/about" element={<AboutPage />} />     
            <Route path="/contact" element={<ContactPage />} /> 
            <Route path="/games" element={<GamesPage />} /> 
            
            {/* --- Blog Routes --- */}
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/christmas-lights-map-guide" element={<ChristmasLightsMapGuide />} />
            <Route path="/blog/international" element={<InternationalGuide />} />
            <Route path="/blog/international-trail" element={<InternationalLights />} />
            <Route path="/blog/top-5-melbourne" element={<TopMelbourne />} />
            <Route path="/blog/top-5-sydney" element={<TopSydney />} />
            <Route path="/blog/top-5-brisbane" element={<TopBrisbane />} />
            <Route path="/blog/top-5-perth" element={<TopPerth />} />
            <Route path="/blog/top-5-ballarat" element={<TopBallarat />} />
            <Route path="/blog/santa-guide" element={<SantaGuide />} />
            <Route path="/blog/perth-northern-suburbs" element={<PerthNorthernSuburbs />} />
            <Route path="/blog/coastal-lights" element={<CoastalLights />} />
            <Route path="/blog/hidden-gems" element={<HiddenGems />} />
            <Route path="/blog/western-sydney-lights" element={<WesternSydneyLights />} />
            <Route path="/blog/top-ipswich-lights" element={<TopIpswich />} />
            <Route path="/blog/wollongong-lights" element={<TopWollongong />} />
            <Route path="/blog/caboolture-north-brisbane" element={<NorthBrisbane />} />
            <Route path="/blog/macarthur-lights" element={<MacarthurLights />} />
            <Route path="/blog/hunter-valley-lights" element={<HunterValleyLights />} />
            
            {/* Targeted Blog Posts */}
            <Route path="/blog/south-west-sydney" element={<SouthWestSydney />} />
            <Route path="/blog/regional-vic-lights" element={<RegionalVicLights />} />
            <Route path="/blog/regional-wa-lights" element={<RegionalWALights />} />
            <Route path="/blog/coastal-wa-lights" element={<CoastalWA />} />
            <Route path="/blog/south-perth-lights" element={<SouthPerthLights />} />
            <Route path="/blog/glenmore-park-lights" element={<GlenmoreParkGuide />} />
            <Route path="/blog/shepparton-lights" element={<SheppartonGuide />} />
            <Route path="/blog/townsville-lights" element={<TownsvilleGuide />} />
            <Route path="/blog/ivanhoe-lights" element={<IvanhoeGuide />} />
            <Route path="/blog/kalgoorlie-lights" element={<KalgoorlieGuide />} />
            <Route path="/blog/southern-nsw-lights" element={<SouthernNSWLights />} />
            
            {/* Regional & Coastal Guides */}
            <Route path="/blog/sunshine-coast-lights" element={<SunshineCoastLights />} />
            <Route path="/blog/whyalla-lights" element={<WhyallaGuide />} />
            <Route path="/blog/clarence-town-lights" element={<ClarenceTownGuide />} />
            <Route path="/blog/atwell-christmas-lights" element={<AtwellGuide />} />
            <Route path="/blog/bathurst-lights" element={<BathurstGuide />} />
            <Route path="/blog/western-vic-lights" element={<WesternVicLights />} />
            <Route path="/blog/gippsland-lights" element={<GippslandLights />} />
            <Route path="/blog/goulburn-lights" element={<GoulburnGuide />} />
            <Route path="/blog/cairns-lights" element={<CairnsGuide />} />
            <Route path="/blog/brisbane-southside-lights" element={<BrisbaneSouthside />} />
            <Route path="/blog/dubbo-lights" element={<DubboGuide />} />
            <Route path="/blog/southern-adelaide-lights" element={<SouthernAdelaideLights />} />
            <Route path="/blog/melbourne-north-west-lights" element={<MelbourneNorthWest />} />
            <Route path="/blog/geelong-lights" element={<GeelongLights />} />
            <Route path="/blog/central-coast-lights" element={<CentralCoastLights />} />
            <Route path="/blog/sutherland-shire-lights" element={<SutherlandShireLights />} />
            <Route path="/blog/regional-qld-lights" element={<RegionalQLDLights />} />
            <Route path="/blog/yeppoon-lights" element={<YeppoonGuide />} />
            <Route path="/blog/blue-mountains-lights" element={<BlueMountainsLights />} />
            <Route path="/blog/redcliffe-lights" element={<RedcliffeGuide />} />
            <Route path="/blog/echuca-moama-lights" element={<EchucaMoamaGuide />} />
            <Route path="/blog/newcastle-north-lights" element={<NewcastleNorthLights />} />
            <Route path="/blog/melbourne-northern-lights" element={<MelbourneNorthernLights />} />
            <Route path="/blog/melbourne-bayside-lights" element={<MelbourneBaysideLights />} />
            <Route path="/blog/hobart-south-lights" element={<HobartSouthLights />} />
            <Route path="/blog/east-gippsland-lights" element={<EastGippslandLights />} />
            <Route path="/blog/penrith-lights" element={<PenrithLights />} />
            <Route path="/blog/narangba-lights" element={<NarangbaLights />} />
            <Route path="/blog/cockburn-lights" element={<CockburnLights />} />
            <Route path="/blog/sydney-north-shore-lights" element={<SydneyNorthShoreLights />} />
            <Route path="/blog/port-macquarie-lights" element={<PortMacquarieLights />} />
            <Route path="/blog/toowoomba-lights" element={<ToowoombaLights />} />
            <Route path="/blog/logan-city-lights" element={<LoganCityLights />} />
            <Route path="/blog/warrnambool-lights" element={<WarrnamboolLights />} />
            <Route path="/blog/gold-coast-lights" element={<GoldCoastLights />} />
            <Route path="/blog/rockingham-lights" element={<RockinghamLights />} />
            <Route path="/blog/broken-hill-lights" element={<BrokenHillLights />} />
            <Route path="/blog/whyalla-lights" element={<WhyallaLights />} />
            <Route path="/blog/bendigo-lights" element={<BendigoLights />} />
            <Route path="/blog/numurkah-lights" element={<NumurkahLights />} />
            <Route path="/blog/kerang-lights" element={<KerangLights />} />
            <Route path="/blog/ipswich-lights" element={<IpswichLights />} />
            <Route path="/blog/caboolture-lights" element={<CabooltureLights />} />
            <Route path="/blog/shepparton-lights" element={<SheppartonLights />} />
            <Route path="/blog/dubbo-lights" element={<DubboLights />} />
            <Route path="/blog/cairns-lights" element={<CairnsLights />} />
            <Route path="/blog/hills-district-lights" element={<HillsDistrictLights />} />
            <Route path="/blog/melbourne-west-lights" element={<MelbourneWestLights />} />
            <Route path="/blog/northern-beaches-lights" element={<NorthernBeachesLights />} />
            <Route path="/blog/mandurah-lights" element={<MandurahLights />} />
            <Route path="/blog/northern-adelaide-lights" element={<NorthernAdelaideLights />} />
            <Route path="/blog/rowville-lights" element={<RowvilleLights />} />
            <Route path="/blog/maryborough-lights" element={<MaryboroughLights />} />
            <Route path="/blog/melbourne-outer-west-lights" element={<MeltonLights />} />
            <Route path="/blog/tweed-heads-lights" element={<TweedLights />} />
            <Route path="/blog/port-pirie-lights" element={<PortPirieLights />} />
            <Route path="/blog/atwell-christmas-lights" element={<AtwellLights />} />
            <Route path="/blog/gregory-hills-lights" element={<GregoryHillsLights />} />
            <Route path="/blog/wollongong-lights" element={<WollongongLights />} />
            <Route path="/blog/kalgoorlie-lights" element={<KalgoorlieLights />} />
            <Route path="/blog/currambine-lights" element={<CurrambineLights />} />
            <Route path="/blog/bairnsdale-lights" element={<BairnsdaleLights />} />
            <Route path="/blog/cairns-cavalcade" element={<CairnsCavalcade />} />
            <Route path="/blog/gregory-hills-lights" element={<GregoryHills />} />
            <Route path="/blog/australia-map" element={<AustraliaMap />} />
            <Route path="/blog/traralgon-lights" element={<TraralgonLights />} />
            <Route path="/blog/caboolture-morayfield-guide" element={<CabooltureGuide />} />
            <Route path="/blog/ivanhoe-boulevard-detailed" element={<IvanhoeBoulevard />} />
            <Route path="/blog/central-coast-2025" element={<CentralCoast2025 />} />
            <Route path="/blog/victoria-weekend-guide" element={<VictoriaWeekendGuide />} />
            <Route path="/blog/christmas-eve-guide-2025" element={<ChristmasEveGuide />} />
            <Route path="/blog/christmas-day-guide-2025" element={<ChristmasDayGuide />} />
            <Route path="/blog/christmas-day-boxing-day-guide" element={<ChristmasDayBoxingDay />} />
            <Route path="/blog/nsw-weekend-guide" element={<NSWWeekendGuide />} />
            <Route path="/blog/new-years-eve-fireworks-2025" element={<NYEFireworks2025 />} />
            <Route path="/blog/new-years-eve-fireworks-2026" element={<NYEFireworks2026 />} />
            <Route path="/blog/qld-weekend-guide" element={<QLDWeekendGuide />} />
            <Route path="/blog/sa-weekend-guide" element={<SAWeekendGuide />} />
            <Route path="/blog/wa-weekend-guide" element={<WAWeekendGuide />} />
            
            {/* --- State & Territory Guides --- */}
            <Route path="/blog/best-lights-vic" element={<BestLightsVIC />} />
            <Route path="/blog/best-lights-nsw" element={<BestLightsNSW />} />
            <Route path="/blog/best-lights-qld" element={<BestLightsQLD />} />
            <Route path="/blog/best-lights-wa" element={<BestLightsWA />} />
            <Route path="/blog/best-lights-sa" element={<BestLightsSA />} />
            <Route path="/blog/best-lights-tas" element={<BestLightsTAS />} />
            <Route path="/blog/best-lights-act" element={<BestLightsACT />} />
            <Route path="/blog/best-lights-nt" element={<BestLightsNT />} />

            {/* --- 2026 Routes --- */}
            <Route path="/blog/festive-expectations" element={<FestiveExpectations />} />

            {/* --- Dynamic Suburb Route --- */}
            <Route path="/lights/:state/:suburb/:postcode" element={<SuburbPage />} />
            
            {/* --- Password Reset --- */}
            <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

            <Route path="/goodbye" element={<GoodbyePage />} />

          </Routes>
        </Suspense>
      </Box>

      <Footer /> 
    </Box>
  );
}

export default App;